import masker from './masker'

export default function (value) {
  if (value.length <= 11) {
    return masker(value, '###.###.###-##')
  }
  return masker(value, '##.###.###/####-##')
}
